// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const WorldmapIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="WorldmapIcon" ref={forwardedRef} {...props}>
      <path d="M12.202 17.692A8 8 0 1 0 8.06 2.238a8 8 0 0 0 4.14 15.454M11.932 3.72 11.85 3.91l.226.556-.304.61c.097.048.196.134.289.214.167.144.313.27.386.123.469-.064.957.105 1.142.197l.159.08.133.724-1.374.313L12.252 6.6l-1.233.67c.007.155.013.483-.02.55-.035.067-.343.346-.493.478l-.14.786.677.576c.119-.02.388-.044.515.02.049.023.052.087.055.171.006.136.014.324.223.478l.121.687.164 1.441 1.018.965.381-.87.498-.232s.21-1.152.287-1.304.222-.426.694-.476l1.63-.802a6.503 6.503 0 0 1-7.666 6.623L8.908 16.13l.832-.2.04-1.277.854-.974.07-.873c-.11.117-.515.002-.668-.18-.084-.098-.091-.147-.103-.223-.014-.098-.036-.242-.238-.6-.125-.221-.082-.441-.045-.633.048-.25.087-.45-.261-.544l-1.175.028-1.305.186-.771-.389-.415-.3-.266-1.487h1.326l1.133-.75-.142-.68.362-.22L8.344 6.4l1.153-1.407-.505-.998.213-.465a6.5 6.5 0 0 1 2.727.188M4.333 9.615l.572 2.399 1.061.541.27 1.13.547.913.259 1.086a6.48 6.48 0 0 1-3.19-4.037 6.5 6.5 0 0 1-.11-2.882z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const WorldmapIcon = /* @__PURE__ */ Object.assign(
  WorldmapIconComponent,
  { displayName: 'WorldmapIcon' },
);
